import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, FileText, Mail, CreditCard, LogOut, ShieldCheck, Globe } from 'lucide-react';
import { logout } from '../lib/auth';
import { cn } from '../lib/utils';
import { useLang, Lang } from '../lib/i18n';

export function Sidebar() {
  const { t, lang, setLang } = useLang();

  const nav = [
    { to: '/',           icon: LayoutDashboard, label: t.nav.dashboard  },
    { to: '/reports',    icon: FileText,         label: t.nav.reports    },
    { to: '/onboarding', icon: Mail,             label: t.nav.onboarding },
    { to: '/billing',    icon: CreditCard,       label: t.nav.billing    },
  ];

  return (
    <aside className="flex flex-col w-60 min-h-screen bg-white border-r border-gray-100 py-6">
      {/* Logo */}
      <div className="px-6 mb-8 flex items-center gap-2">
        <ShieldCheck className="h-7 w-7 text-brand-600" />
        <span className="text-lg font-bold text-gray-900">XyloTrust</span>
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1 px-3">
        {nav.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors',
                isActive
                  ? 'bg-brand-50 text-brand-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
              )
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Language toggle */}
      <div className="px-4 py-3 border-t border-gray-100 mt-4">
        <div className="flex items-center gap-2 mb-1.5">
          <Globe className="h-3.5 w-3.5 text-gray-400" />
          <span className="text-xs font-medium text-gray-400 uppercase tracking-wide">{t.lang.label}</span>
        </div>
        <div className="flex rounded-lg border border-gray-200 overflow-hidden">
          {(['nl', 'en'] as Lang[]).map(l => (
            <button
              key={l}
              onClick={() => setLang(l)}
              className={cn(
                'flex-1 py-1.5 text-xs font-medium transition-colors',
                lang === l
                  ? 'bg-brand-600 text-white'
                  : 'text-gray-500 hover:bg-gray-50',
              )}
            >
              {t.lang[l]}
            </button>
          ))}
        </div>
      </div>

      {/* Logout */}
      <div className="px-3">
        <button
          onClick={() => logout()}
          className="flex w-full items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900 transition-colors"
        >
          <LogOut className="h-4 w-4" />
          {t.nav.logout}
        </button>
      </div>
    </aside>
  );
}
